.root:not(:last-child) {
  margin-bottom: 10px;
}

.name {
  font-weight: bold;
}

.pending {
  width: 10px;
  height: 10px;
  background: #FFC107;
  border-radius: 50%;
}
